import { z } from 'zod';

import { TAB_FILTER } from './-constants';

export const GroupIdMemberSortColumns = {
  PERSON_NAME: 'person',
  ORGANIZATION: 'organization',
  POSITION: 'position',
} as const;

/**
 * URL検索パラメータのスキーマ
 * NOTE: API パラメータ (orderBy/orderDirection) は DataScreen 内で
 * sortColumn/sortOrder から変換して構築するため、URL スキーマには含めない
 */
export const SearchSchema = z.object({
  category: z.nativeEnum(TAB_FILTER).optional().default(TAB_FILTER.FOLLOWING),
  freeText: z.string().optional(),
  page: z.number().int().min(1).optional().default(1),
  pageSize: z.number().int().min(1).optional().default(100),
  sortColumn: z
    .enum([
      GroupIdMemberSortColumns.PERSON_NAME,
      GroupIdMemberSortColumns.ORGANIZATION,
      GroupIdMemberSortColumns.POSITION,
    ])
    .optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
